import { render, staticRenderFns } from "./TypeVenteEdit.vue?vue&type=template&id=56575d96&"
import script from "./TypeVenteEdit.vue?vue&type=script&lang=js&"
export * from "./TypeVenteEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56575d96')) {
      api.createRecord('56575d96', component.options)
    } else {
      api.reload('56575d96', component.options)
    }
    module.hot.accept("./TypeVenteEdit.vue?vue&type=template&id=56575d96&", function () {
      api.rerender('56575d96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/type_vente/TypeVenteEdit.vue"
export default component.exports